import { Rule } from './wxRule';
import { Detail } from './wxDetail';

export class Options {
    public rule!: Rule;
    public detail!: Detail;

    constructor(rule?: Rule, detail?: Detail) {
        if (rule) {
            this.rule = rule;
        }
        if (detail) {
            this.detail = detail;
        }
    }
}
